import React, { Dispatch, SetStateAction, useState } from 'react';
import Button from '../../../components/Button';
import Input from '../../../components/Input';
import CheckBox from '../../../components/MenuTable/components/CheckBox';
import Modal from '../../../components/Modal';
import Image from '../../../components/ProductImageDetail';
import Text from '../../../components/Text';
import TextArea from '../../../components/TextArea';
import useForm from '../../../hooks/useForm';
import { IDessert } from '../../../models/IDessert';
import { getAuthenticatedToken } from '../../../redux/auth';
import { putDessertAsync } from '../../../redux/dessertSlice/thunks';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { loadImage } from '../../../utils/file';
import { getFieldSchema } from '../../../utils/getFieldSchema';
import { fieldSchema } from '../CreateDessert/schemas';
import { ContainerInput, StyledButtons, SwitchContainerStyled } from './styles';

interface IEditDessertProps {
  selectedDessert: IDessert;
  isOpent: boolean;
  setIsOpent: Dispatch<SetStateAction<boolean>>;
  onClickDelete: () => void;
}

export interface IUpdateDessert {
  name: string;
  description: string;
  file: File | undefined;
  isActive: string;
}

const EditDessert = ({ selectedDessert, isOpent, setIsOpent, onClickDelete }: IEditDessertProps) => {
  const { name, description, isActive, _id, img_url } = selectedDessert;
  const schema = getFieldSchema({
    fieldSchema,
    fieldValues: { name, description, isActive },
  });
  const { fields, onChangeField, errors, isValidForm } = useForm({
    fieldSchema: schema,
  });
  const [image, setImage] = useState<{ file: File | undefined; src: string }>();
  const token = useAppSelector(getAuthenticatedToken);
  const dispatch = useAppDispatch();

  const onSend = () => {
    const dessert: IUpdateDessert = {
      name: fields.name,
      description: fields.description,
      file: image?.file,
      isActive: String(fields.isActive),
    };
    dispatch(putDessertAsync({ dessertId: _id, dessert, token }));
    setIsOpent(false);
  };

  const onChangeImage = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const src = await loadImage(e.target.files[0]);
      setImage({ src, file: e.target.files[0] });
    }
  };

  return (
    <Modal isOpent={isOpent} setIsOpent={setIsOpent} size="sm">
      <Text type="h3" weight="bold" alignment="start" color="principal">
        Editar postre
      </Text>
      <Image onChange={onChangeImage} src={image?.src ?? img_url} data-testid="image-input" />
      <ContainerInput>
        <Input
          data-testid="name-test"
          value={fields.name}
          onChange={(value) => onChangeField({ name: 'name', value })}
          type="Name"
          label="Nombre"
          border
          messageError={errors.name?.message}
          error={errors.name?.error}
        />
      </ContainerInput>
      <TextArea
        data-testid="desc-test"
        value={fields.description}
        onChange={(e) => onChangeField({ name: 'description', value: e.target.value })}
        label="Descripción"
      />
      <SwitchContainerStyled>
        <Text type="body" alignment="start">
          Visible en la web
        </Text>
        <div>
          <CheckBox
            checked={fields.isActive}
            onChange={(e) => onChangeField({ name: 'isActive', value: e.target.checked })}
          />
          <Text type="body" alignment="start">
            Si
          </Text>
        </div>
      </SwitchContainerStyled>
      <StyledButtons>
        <Button data-testid="close-test" size="xs" variant="black" onClick={onClickDelete}>
          Eliminar
        </Button>
        <Button size="xs" onClick={onSend} data-testid="dessert-save-btn" disabled={!isValidForm}>
          Guardar
        </Button>
      </StyledButtons>
    </Modal>
  );
};

export default EditDessert;
